export const CARTERIZATION_SERVICE = 'CARTERIZACION'
export const FREEDOM_AND_FLOW_SERVICE = 'Freedom'
export const OPENHEALTHCARE_API_SERVICE = 'OpenhealthcareApi'
export const OPENSALUD_PRIME_SERVICE = 'Opensalud prime'
export const PRESCRYPTO_SERVICE = 'Prescrypto'
export const TELEMEDCARE_SERVICE = 'Telemedcare'
export const WELLWO_SERVICE = 'Wellwo'
export const HEALTHY_COMMUNITY_SERVICE = 'Comunidad'
export const SEARCH_SERVICE = 'Search'
export const TEST_PSYCHOSOCIAL_RISKS = "Test psychosocial risks"
export const TEST_RYFF_SCALE = "Test ryff scale"
export const TEST_FINDRISK = "Test findrisk";
export const TEST_MEDITERRANEAN_DIET = "Test mediterranean diet"
export const TEST_NICOTINE_DEPENDENCY = "Test nicotine dependency"
export const TEST_STRESS = "Test stress"
export const TEST_SLEEP_QUALITY = "Test sleep quality"
export const TEST_ANXIETY_BECK = "Test anxiety beck"
export const TEST_PHYSICAL_ACTIVITY = "Test physical activity"
export const TEST_CARDIOVASCULAR_RISK = "Test cardiovascular risk"
export const TEST_GENERAL_HEALTH = "Test general health"
export const TEST_INTERPERSONAL_RELATIONSHIPS = "Test interpersonal relationships"
export const TEST_SOCIAL_SKILLS = "Test social skills"
export const TEST_WORK_ENVIRONMENT = "Test work environment"
export const REHANDREBODY_SERVICE = 'RehBody'

export const EVALUATE_HEALTH_TESTS = [TEST_PSYCHOSOCIAL_RISKS, TEST_RYFF_SCALE, TEST_FINDRISK, TEST_ANXIETY_BECK, TEST_CARDIOVASCULAR_RISK, TEST_STRESS, TEST_GENERAL_HEALTH, TEST_SLEEP_QUALITY, TEST_MEDITERRANEAN_DIET, TEST_PHYSICAL_ACTIVITY, TEST_NICOTINE_DEPENDENCY, TEST_INTERPERSONAL_RELATIONSHIPS, TEST_SOCIAL_SKILLS, TEST_WORK_ENVIRONMENT]

export const COMPANIES_TESTS = [TEST_PSYCHOSOCIAL_RISKS, TEST_RYFF_SCALE, TEST_WORK_ENVIRONMENT, FREEDOM_AND_FLOW_SERVICE]
export const ONLY_360_USERS_TESTS = [TEST_PHYSICAL_ACTIVITY, TEST_STRESS, TEST_INTERPERSONAL_RELATIONSHIPS]

export const POSITIVE_IMPACT_TESTS = [TEST_RYFF_SCALE, TEST_MEDITERRANEAN_DIET, TEST_SLEEP_QUALITY, TEST_PHYSICAL_ACTIVITY, TEST_GENERAL_HEALTH, TEST_INTERPERSONAL_RELATIONSHIPS, TEST_SOCIAL_SKILLS, TEST_WORK_ENVIRONMENT]

export const NEGATIVE_IMPACT_TESTS = [TEST_FINDRISK, TEST_NICOTINE_DEPENDENCY, TEST_STRESS, TEST_ANXIETY_BECK, TEST_CARDIOVASCULAR_RISK]

export const NOT_IN_MX_TESTS = [TEST_MEDITERRANEAN_DIET]

export const PHYSICAL_HEALTH_TESTS = {name: 'physical-tests', tests: [TEST_GENERAL_HEALTH, TEST_FINDRISK, TEST_CARDIOVASCULAR_RISK, TEST_SLEEP_QUALITY, TEST_MEDITERRANEAN_DIET, TEST_PHYSICAL_ACTIVITY, TEST_NICOTINE_DEPENDENCY]}
export const MENTAL_HEALTH_TESTS = {name: 'mental-tests', tests: [TEST_RYFF_SCALE, TEST_STRESS, TEST_ANXIETY_BECK, TEST_INTERPERSONAL_RELATIONSHIPS, TEST_SOCIAL_SKILLS]}
export const INDEPENDENT_TESTS = {name: 'independent-tests', tests: [TEST_PSYCHOSOCIAL_RISKS, TEST_WORK_ENVIRONMENT]}


// WEBPACK FOOTER //
// ./src/constants/patientServices.js